import { render, staticRenderFns } from "./BenchmarkTickerForm.vue?vue&type=template&id=f10e96c6&"
import script from "./BenchmarkTickerForm.vue?vue&type=script&lang=js&"
export * from "./BenchmarkTickerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports